// import {  } from "draft-js";
import React, { useEffect, useState } from 'react';
import { compositeDecorator, ContentState, convertFromHTML, convertToRaw, Editor, EditorState } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";


const EditorContainer = () => {


    const [editorState, seteditorState] = useState(EditorState.createEmpty());
    const [saveValue, setSaveValue] = useState();
    const [storedState, SetStoredState] = useState({});

    // this.state = {
    //     editorState: EditorState.createEmpty(),
    //   };

    const handleSave = () => {
        const editorJSON = JSON.stringify(convertToRaw(editorState.getCurrentContent()));
        console.log(editorJSON);
        setSaveValue(editorJSON)
        // console.log(editorState.getCurrentContent());
        // const blocks = convertToRaw(editorState.getCurrentContent()).blocks;
        // const value = blocks.map(block => (!block.text.trim() && '\n') || block.text).join('\n');
        // console.log(value);
        // setSaveValue(value); 
    }

    // useEffect(() => {
    //     const storedState = ConvertFromRaw(JSON.parse(saveValue));
    //     SetStoredState(storedState)
    // }, [])
    const onEditorStateChange = (editorState) => {
        seteditorState(editorState)
        // console.log(editorState)
        // this.setState({
        //   editorState,
        // });
    };

    const componentWillMount = () => {
        // const { value } = this.props
        const blocksFromHTML = convertFromHTML(saveValue)
        const state = ContentState.createFromBlockArray(
            blocksFromHTML.contentBlocks,
            blocksFromHTML.entityMap,
        );
        seteditorState(EditorState.createWithContent(
            state,
            compositeDecorator,
        ))
        // this.state = {
        //   editorState: 
        // };
    }
    useEffect(() => {
        // componentWillMount()
    }, [])
    function uploadImageCallBack(file) {
        return new Promise(
            (resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open('POST', 'https://api.imgur.com/3/image');
                xhr.setRequestHeader('Authorization', 'Client-ID ##clientid##');
                const data = new FormData();
                data.append('image', file);
                xhr.send(data);
                xhr.addEventListener('load', () => {
                    const response = JSON.parse(xhr.responseText);
                    console.log(response)
                    resolve(response);
                });
                xhr.addEventListener('error', () => {
                    const error = JSON.parse(xhr.responseText);
                    console.log(error)
                    reject(error);
                });
            }
        );
    }


    return (
        <>
            <div>
                <button onClick={handleSave}>SAVE</button>
            </div>
            <div className="readonly-editor">
                <Editor editorState={storedState} readOnly={true} />
            </div>
            <div className='editor'>
                <Editor
                    editorState={editorState}
                    onEditorStateChange={onEditorStateChange}
                    toolbar={{
                        inline: { inDropdown: true },
                        list: { inDropdown: true },
                        textAlign: { inDropdown: true },
                        link: { inDropdown: true },
                        history: { inDropdown: true },
                        image: { uploadCallback: uploadImageCallBack, alt: { present: true, mandatory: true } },
                    }}
                />
            </div>
        </>
    );
};

export default EditorContainer;
//